import React from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { ProjectsWrapper } from '../Components/ProjectsWrapper'
import { ProjectsMainContent } from '../Components/ProjectMainContent'

export const ProjectListingDesktop = observer(() => {
  const { t } = useTranslation('global')

  return (
    <ProjectsWrapper
      header={<></>}
      children={
        <ProjectsMainContent
          subtitle={t('Projects.view_invoice_and_add_project')}
          title={t('Projects.projects')}
        />
      }
    />
  )
})
